import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UserCard } from 'components/Card';
import Notifications from 'components/Notifications';
import ChatNotifications from 'components/ChatNotifications';
import withBadge from 'hocs/withBadge';
import { useCookies } from 'react-cookie';
import { toast, ToastContainer } from 'react-toastify';
import ProfileImage from 'assets/img/bis/profile_placeholder.png';
import axios from 'axios';
// import moment from 'moment';
import moment from 'moment-timezone';
import { TbMessageReportFilled, TbMessageDots } from "react-icons/tb";
import { BsChatDots } from 'react-icons/bs';
import CustomToast from 'utils/CustomToast';

import {
  MdExitToApp,
  MdMessage,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
  MdSettingsApplications,
} from 'react-icons/md';
import { RiMessage2Fill, RiMessage2Line } from "react-icons/ri";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  Row,
} from 'reactstrap';
import bn from 'utils/bemnames';
import firestore from '../../firebaseConfig';

const bem = bn.create('header');

const MdMessagesActiveWithBadge = withBadge({
  size: 'md',
  color: 'primary',
  style: {
    top: -10,
    right: -10,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  children: <small>0</small>,
})(MdMessage);

const initialContactData = Object.freeze({
  user_id: '',
  // name: '',
  // email: '',
  subject: '',
  message: '',
});

const initialPasswordData = Object.freeze({
  current_password: '',
  new_password: '',
  confirm_password: '',
  user_id: '',
  token: '',
});

const initialEntrantData = Object.freeze({
  first_name: '',
  last_name: '',
  company_name: '',
  company_position: '',
  contact_phone: '',
  company_email: '',
  address_line_1: '',
  address_line_2: '',
  city: '',
  province: '',
  company_industry: '',
  company_phone: '',
  email: '',
  image_url: '',
});

const initialCountdown = Object.freeze({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
})

function Header() {
  const id = '1';
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();
  const parameter_award_id = query.get('award_id');
  const action = query.get('action');
  const module = query.get('module');
  const artworkId = query.get('artwork_id');
  const surveyId = query.get('survey_id');
  const booking_code = query.get('booking_code');
  const po = query.get('po');

  const location = useLocation();
  var currentPathName = location.pathname;
  const [cookies, setCookie, removeCookie] = useCookies(['reloadHeader', 'currentUser', 'isLoggedIn', 'award_id', 'section', 'token', 'userDetails', 'award_domain']);
  // const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  const currentUser = cookies.currentUser;
  const userDetails = cookies.userDetails;
  const reloadHeader = cookies.reloadHeader;
  const award_domain = cookies.award_domain;

  // const isLoggedIn = sessionStorage.getItem("IsLoggedIn");
  const isLoggedIn = cookies.isLoggedIn;
  //const userRole = cookies.userRole;
  const section = cookies.section;
  const token = cookies.token;
  const currentHost = window.location.hostname;

  const [userRole, setUserRole] = useState(cookies.userRole);
  const [judge, setJudge] = useState(cookies.judge);
  const [awardStatus, setAwardStatus] = useState('');
  const [award_id, setAwardId] = useState(parameter_award_id ? parameter_award_id : cookies.award_id);

  const [singleProfile, setSingleProfile] = useState();
  const [profileData, setProfileData] = useState(initialEntrantData);
  const [passwordData, setPasswordData] = useState(initialPasswordData);
  const [showPasswordUpdate, setShowPasswordUpdate] = useState(false);
  const [imgFile, setImgFile] = useState('');

  let history = useHistory();
  const [user, setUser] = useState([]);
  const [isOpenNotificationPopover, setIsOpenNotificationPopover] = useState(false);
  const [isOpenChatPopover, setIsOpenChatPopover] = useState(false);
  const [isNotificationConfirmed, setIsNotificationConfirmed] = useState(false);
  const [isChatNotificationConfirmed, setIsChatNotificationConfirmed] = useState(false);

  const [isOpenMessageNotificationPopover, setIsOpenMessageNotificationPopover] = useState(false);
  const [isMessageNotificationConfirmed, setIsMessageNotificationConfirmed] = useState(false);

  const [isUnreadMessage, setIsUnreadMessage] = useState(false);

  const [isOpenUserCardPopover, setIsOpenUserCardPopover] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [contactData, setContactData] = useState(initialContactData);
  const [formStatus, setFormStatus] = useState('standby');
  const [notifications, setNotifications] = useState();
  const [notificationsCount, setNotificationsCount] = useState(0);

  const [eventStart, setEventStart] = useState();
  const [eventStartTime, setEventStartTime] = useState();
  const [eventDeadLine, setEventDeadLine] = useState();
  const [timeLeft, setTimeLeft] = useState('');
  const [entryTimeLeft, setEntryTimeLeft] = useState(initialCountdown);
  const [entryBegin, setEntryBegin] = useState(initialCountdown);
  const [entryDeadline, setEntryDeadline] = useState(initialCountdown);
  const [entryDeadlineExtension, setEntryDeadlineExtension] = useState(initialCountdown);
  const [galaDate, setGalaDate] = useState(initialCountdown);
  const [countdownText, setCountdownText] = useState("");
  const [judgingTimeLeft, setJudgingTimeLeft] = useState(initialCountdown);
  const [judgingBegins, setJudgingBegins] = useState(initialCountdown); 
  const [shortlistingTimeLeft, setShortlistingLeft] = useState(initialCountdown);
  const [shortlistingBegins, setShortlistingBegins] = useState(initialCountdown);
  const [reloadCount, setReloadCount] = useState(1);
  const [userType, setUserType] = useState('');
  const [maintenance, setMaintenance] = useState(false);

  const [userNotification, setUserNotification] = useState([]);
  const [companyLogo, setCompanyLogo] = useState('');
  const [eventLogo, setEventLogo] = useState('');

  const [chatsLoading, setChatsLoading] = useState(true);
  const [unreadAwards, setUnreadAwards] = useState([]);
  const [awardReady, setAwardReady] = useState(false);

  const [awardDomain, setAwardDomain] = useState('');
  const ukAwards = [110, 124, 108];

  const [awardEntryStatus, setAwardEntryStatus] = useState(null);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const firstSegment = pathParts[1];
    const localePrefixes = ['ie', 'uk'];

    if (localePrefixes.includes(firstSegment)) {
      const cleanPath = '/' + pathParts.slice(2).join('/');
      const newUrl = cleanPath + location.search; // ✅ keep query string
      history.replace(newUrl); // ⬅️ redirect with old react-router
    }
  }, [location.pathname, location.search, history]);

  const MdNotificationsActiveWithBadge = withBadge({
    size: 'md',
    color: 'primary',
    style: {
      top: -10,
      right: -10,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    children: <small>{notificationsCount}</small>,
  })(MdNotificationsActive);

  const TbMessageReportFilledBadge = withBadge({
    size: 'md',
    color: 'primary',
    style: {
      top: -10,
      right: -10,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    children: <small className="text-white">{unreadAwards.length}</small>,
  })(TbMessageReportFilled);

  const getSponsorshipAgreement = async () => {
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'sponsorship/agreement?award_id=' + award_id + '&user_id=' + currentUser + '&token=' + token);
  };

  const getUnreadMessage = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + 'admin/' + currentUser + '/chat', {
      params: {
        user_id: currentUser,
        token: token
      },
    })
  }

  const retrieveUserNotifications = async () => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'user/' + currentUser + '/summary?status=Unread&user_id=' + currentUser + '&token=' + token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const removeCookies = () => {
    removeCookie('token', { path: '/' });
    removeCookie('userDetails', { path: '/' });
    removeCookie('awardSettings', { path: '/' });
    removeCookie('isWelcome', { path: '/' });
    removeCookie('currentUser', { path: '/' });
    removeCookie('isLoggedIn', { path: '/' });
    removeCookie('userRole', { path: '/' });
    removeCookie('judge', { path: '/' });
    removeCookie('judge_id', { path: '/' });
    removeCookie('coordinator_id', { path: '/' });
    removeCookie('isAccept', { path: '/' });
    removeCookie('isProceed', { path: '/' });
    removeCookie('section', { path: '/' });
    removeCookie('award_id', { path: '/' });
    removeCookie('cookie_section', { path: '/' });
    removeCookie('cookie_award_id', { path: '/' });
    removeCookie('isSubmit', { path: '/' });
    removeCookie('awardStatus', { path: '/' });
    // Remove survey completion status
    removeCookie('surveyStatus', { path: '/' });
  };

  const handleClose = (e) => {
    setShowContact(false);
  };

  const handleChange = (e) => {
    setContactData({
      ...contactData,
      [e.target.name]: e.target.value,
      user_id: currentUser,
    });
  };

  const handleShowContact = (e) => {
    //e.preventDefault();
    setShowContact(true);
  };

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const toggleNotificationPopover = () => {
    setIsOpenNotificationPopover(!isOpenNotificationPopover);
    setIsOpenUserCardPopover(false);
    setIsOpenChatPopover(false);
    setIsMessageNotificationConfirmed(false);
    if (!isNotificationConfirmed) {
      setIsNotificationConfirmed(true);
    }
  };

  const toggleChatPopover = () => {
    setIsOpenChatPopover(!isOpenChatPopover);
    setIsOpenNotificationPopover(false);
    setIsOpenUserCardPopover(false);
    setIsMessageNotificationConfirmed(false);
    setChatsLoading(true);
    if (!isChatNotificationConfirmed) {
      setIsChatNotificationConfirmed(true);
    }
  };

  const handleViewMessages = () => {
    history.push('/entrant/chat');
  }

  const toggleMessageNotificationPopover = () => {
    setIsOpenMessageNotificationPopover(!isOpenMessageNotificationPopover);
    if (!isMessageNotificationConfirmed) {
      setIsMessageNotificationConfirmed(true);
    }
  };

  const toggleUserCardPopover = () => {
    setIsOpenUserCardPopover(!isOpenUserCardPopover);
    setIsOpenNotificationPopover(false);
    setIsMessageNotificationConfirmed(false);
    setIsOpenChatPopover(false);
  };

  const handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  const retrieveUser = async () => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'user/' + currentUser + '?user_id=' + currentUser + '&token=' + token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  async function submitContact(e) {
    e.preventDefault();
    if (contactData.subject != '' && contactData.message != '') {
      setFormStatus('loading');
      // if (validator.isEmail(contactData.email)) {
      const response = await fetch(process.env.REACT_APP_API_ENDPOINT + 'inquiry' + '?user_id=' + currentUser + '&token=' + token, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'omit', // include, *same-origin, omit
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': true,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
          'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
        },
        redirect: 'follow', // manual, *follow, error
        referrer: 'client', // no-referrer, *client
        body: JSON.stringify(contactData), // body data type must match "Content-Type" header
      });

      const json = await response.json();

      if (json.status == 'Success') {
        //alert("Award created successfully");
        toast.success('Message sent successful!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // setUpdateEntryCommentModal(false);
        // setUpdateEntryCommentModalShow(false);
        setFormStatus('standby');

      } else {
        toast.error('Failed to Submit, please try again!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFormStatus('standby');
      }
    } else {
      toast.error('Please fill up all fields!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setFormStatus('standby');
    }
  }

  const retrieveAwardByDomain = async (domain) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award-type/award?domain='+domain+'&award_id='+award_id+'&user_id=' + currentUser + '&token=' + token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  function deadlineTime(date, time = ' 23:59:59') {
    moment.tz.setDefault('Europe/Dublin');

    const countDownDate = moment.tz(date + time, "Europe/Dublin");
    const now = moment();
    const duration = moment.duration(countDownDate.diff(now));

    const days = duration.asDays();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();


    return {
      days: Math.floor(days),
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }

  function calculateTimeLeft(e) {
    const countDownDate = new Date(e).getTime();
    const now = new Date().getTime();
    const distance = countDownDate - now;
    let timeLeft = {};

    if (distance > 0) {
      timeLeft = {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance / 1000) % 60),
      };
    }
    return timeLeft;
  }

  useEffect(() => {
    const getUser = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}profile/${currentUser}`,
        {
          params: {
            user_id: currentUser,
            token: token,
          },
        }
      );

      const data = response.data.data;
      if (data) {
        if (
          data.new_user === '1' &&
          data.email_verified_at === ''
        ) {
          toast.warning("Please verify your email to continue.");
          if (booking_code) {
            {
              history.push(`/verify?code=${booking_code}&po=${po}`);
            }

          } else {
            history.push('/verify');
          }

        }
      }
    };

    if (currentUser) {
      getUser();
    }
  }, [currentUser]);

  useEffect(() => {
    const domain = currentHost.replace(/^[^.]+\./, '');

    const getAwardByDomain = async () => {
      const selectedAward = await retrieveAwardByDomain(domain);
      if (selectedAward) {
        setAwardStatus(selectedAward.status);
        setEventLogo(() => selectedAward.logo);

        setEntryDeadline(deadlineTime(selectedAward.entry_deadline, ' 17:00:00'));
        setEntryBegin(deadlineTime(selectedAward.entry_begins, ' 08:00:00'));
        setEntryDeadlineExtension(deadlineTime(selectedAward.entry_deadline_extension, ' 17:00:00'));
        setGalaDate(deadlineTime(selectedAward.awards_gala_date, ' 18:30:00'));
        setEntryTimeLeft(deadlineTime(selectedAward.entry_deadline, ' 17:00:00'));
        setJudgingTimeLeft(deadlineTime(selectedAward.judging_deadline));
        setJudgingBegins(deadlineTime(selectedAward.judging_begins));
        setShortlistingLeft(deadlineTime(selectedAward.shortlisting_deadline));
        setShortlistingBegins(deadlineTime(selectedAward.shortlisting_begins));

        setAwardEntryStatus(selectedAward.entry_status);

        if (selectedAward.award_website) {
          setCountdownText(selectedAward.award_website.countdown_timer_text);
        } else {
          setCountdownText("");
        }

        if (selectedAward.id) {
          setCookie('award_id', selectedAward.id, { path: '/' });
          const awardType = selectedAward.award_type;
          setAwardId(selectedAward.id);
          setTimeout(function(){
            setAwardReady(true);
          }, 500);
          setCookie('award_domain', awardType.mail_domain, { path: '/' });
          setAwardDomain(awardType.mail_domain);
        } else {
          setTimeout(function(){
            setAwardReady(true);
          }, 500);
        }
      } else {
        setTimeout(function(){
          setAwardReady(true);
        }, 500);
      }
    };
    getAwardByDomain();
  }, []);

  useEffect(() => {
    if (awardReady) {
      if (section === 'sponsor') {
        getSponsorshipAgreement().then(response => {
          const result = response.data.data;
          if (result) {
            if (result.length > 0) {
              setCompanyLogo(() => result[0].image_url);
            }
          } else {

          }
        }).catch(() => {
          toast.error('An error occured. Please try again or contact the administrator.', {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      }

      setPasswordData({
        ...passwordData,
        user_id: currentUser,
        token: token,
      });

      if (currentUser) {
        if (!(currentPathName == '/award/booking' || currentPathName == '/price-quote/summary' || currentPathName == '/award/booking/v1' || currentPathName == '/award/booking/form' || currentPathName == '/award/booking/v2' || currentPathName == '/award/book/v2' || currentPathName == '/award/book/seats/v2' || currentPathName == '/award/book/v1' || currentPathName == '/award/book/seats/v1' || currentPathName == '/account/verification' || currentPathName == '/edit-profile' || currentPathName == '/profile' || currentPathName == '/be-a-sponsor' || currentPathName == '/be-a-judge' || currentPathName == '/involvement' || currentPathName == '/logout')) {
          if (!(currentPathName == '/register' || currentPathName == '/bank/transfer' || currentPathName == '/bank/transfer/terms' || currentPathName == '/report' || currentPathName == '/award/book' || currentPathName == '/award/booking' || currentPathName == '/award/booking/v1' || currentPathName == '/award/booking/v2' || currentPathName == '/award/book/v2' || currentPathName == '/award/book/seats/v2' || currentPathName == '/price-quote/summary' || currentPathName == '/award/book/v1' || currentPathName == '/award/book/seats/v1' || currentPathName == '/award/booking/form' || currentPathName == '/award/book/form' || currentPathName == '/award/book/form/seats' || currentPathName == '/award/book/dynamic' || currentPathName == '/award/book/seats' || currentPathName == '/award/event' || currentPathName == '/booking/summary' || currentPathName == '/booking/summary/unlisted' || currentPathName == "/booking/summary/v2" || currentPathName == '/booking/details' || currentPathName == '/booking/payment/success' || currentPathName == '/booking/payment/success/v2' || currentPathName == '/booking/attendees' || currentPathName == '/booking/attendees/setup' || currentPathName == '/category/winner' || currentPathName == '/award/winner' || currentPathName == "/award/nomination" || currentPathName == '/winner/summary' || currentPathName == '/winner/payment/success' || currentPathName == '/bank/transfer' || currentPathName == '/bank/transfer/terms' || currentPathName == '/tickets' || currentPathName == '/entry/payment/success' || currentPathName == '/invoice/payment/success' || currentPathName == '/stripe' || currentPathName == '/verify')) {
            const firstPath = currentPathName.split('/')[1];
            if (firstPath != '' && firstPath) {
              if (firstPath == 'admin' && userRole != 'Admin') {
                if (section) {
                  setTimeout(function () {
                    history.push('/' + section + '/home');
                  }, 500);
                } else {
                  removeCookies();
                  window.location.href = 'http://app.businessriver.com/';
                }
              } else if (userRole == 'Admin' && firstPath != 'admin') {
                setTimeout(function () {
                  history.push('/admin');
                }, 500);
              } else {
                if (section && firstPath) {
                  if (firstPath != section) {
                    if (firstPath != 'admin') {
                      history.push('/' + section + '/home');
                    }
                  }
                }
              }
            }
          }
        }

        const getUserNotification = async () => {
          const selectedUserNotification = await retrieveUserNotifications();
          // console.log("User Notification",selectedUserNotification.user);
          if (selectedUserNotification) {
            setUserRole(selectedUserNotification.user.role);
            setUser(selectedUserNotification.user);
            setNotifications(selectedUserNotification.notifications);
            setNotificationsCount(selectedUserNotification.notifications.length);

            if (selectedUserNotification.user.role == 'Admin') {
              if (currentPathName == '/admin/invoices') {
                if (selectedUserNotification.user.invoices_view == 0) {
                  history.push('/admin');
                } else if (selectedUserNotification.user.invoices_view == 1) {
                  console.log('Invoices page ready');
                } else {
                  console.log('Go Back!');
                }
              } else if (currentPathName == '/admin/venues' || currentPathName == '/admin/venue' || currentPathName == '/admin/event/information') {
                if (selectedUserNotification.user.venues_view == 0) {
                  history.push('/admin');
                } else if (selectedUserNotification.user.venues_view == 1) {
                  console.log('Venues page ready');
                } else {
                  console.log('Go Back!');
                }
              } else if (currentPathName == '/admin/venue/seating') {
                if (selectedUserNotification.user.seating_view == 0) {
                  history.push('/admin');
                } else if (selectedUserNotification.user.seating_view == 1) {
                  console.log('Seating page ready');
                } else {
                  console.log('Go Back!');
                }
              } else if (currentPathName == '/admin/users' || currentPathName == '/admin/view-profile') {
                if (selectedUserNotification.user.users_view == 0) {
                  history.push('/admin');
                } else if (selectedUserNotification.user.users_view == 1) {
                  console.log('Users page ready');
                } else {
                  console.log('Go Back!');
                }
              } else {
                // console.log(currentPathName);
              }
            }

            if (selectedUserNotification.user) {
              setProfileData({
                ...profileData,
                id: selectedUserNotification.user.id,
                user_id: selectedUserNotification.user.id,
                first_name: selectedUserNotification.user.first_name,
                last_name: selectedUserNotification.user.last_name,
                company_name: selectedUserNotification.user.company_name,
                company_position: selectedUserNotification.user.company_position,
                contact_phone: selectedUserNotification.user.contact_phone,
                company_email: selectedUserNotification.user.company_email,
                address_line_1: selectedUserNotification.user.address_line_1,
                address_line_2: selectedUserNotification.user.address_line_2,
                city: selectedUserNotification.user.city,
                province: selectedUserNotification.user.province,
                company_industry: selectedUserNotification.user.company_industry,
                company_phone: selectedUserNotification.user.company_phone,
                email: selectedUserNotification.user.email,
                image_url: selectedUserNotification.user.image_url,
              });
              setImgFile(selectedUserNotification.user.image_url);
            }

          }
        };
        getUserNotification();

      } else {
        if (currentPathName == '/register' || currentPathName == '/bank/transfer' || currentPathName == '/bank/transfer/terms' || currentPathName == '/report' || currentPathName == '/award/book' || currentPathName == '/price-quote/summary' || currentPathName == '/award/booking' || currentPathName == '/award/booking/v1' || currentPathName == '/award/booking/v2' || currentPathName == '/award/book/v2' || currentPathName == '/award/book/seats/v2' || currentPathName == '/award/book/v1' || currentPathName == '/award/book/seats/v1' || currentPathName == '/award/booking/form' || currentPathName == '/award/book/form' || currentPathName == '/award/book/form/seats' || currentPathName == '/award/book/seats' || currentPathName == '/award/event' || currentPathName == '/booking/summary' || currentPathName == '/booking/summary/unlisted' || currentPathName == '/booking/summary/v2' || currentPathName == '/booking/details' || currentPathName == '/booking/payment/success' || currentPathName == '/booking/payment/success/v2' || currentPathName == '/booking/attendees' || currentPathName == '/booking/attendees/setup' || currentPathName == '/category/winner' || currentPathName == '/award/winner' || currentPathName == "/award/nomination" || currentPathName == '/winner/summary' || currentPathName == '/winner/payment/success' || currentPathName == '/bank/transfer' || currentPathName == '/bank/transfer/terms' || currentPathName == '/tickets' || currentPathName == '/entry/payment/success' || currentPathName == '/invoice/payment/success') {
        } else {
          if (award_id && section) {
            history.push('/' + section + '?award_id=' + award_id);
          } else {
            const firstPath = currentPathName.split('/')[1];
            if (firstPath && firstPath != '') {

              if (parameter_award_id && parameter_award_id != '') {
                if (module === 'procurement') {
                  history.push('/' + firstPath + '/login?award_id=' + parameter_award_id + '&artwork_id=' + artworkId + '&module=' + module);
                } else if (!!surveyId) {
                  history.push('/' + firstPath + '/login?award_id=' + parameter_award_id + '&survey_id=' + surveyId);
                } else {
                  if (firstPath != 'award' && firstPath != 'api') {
                    history.push('/' + firstPath + '/login?award_id=' + parameter_award_id);
                  } else {
                    history.push('/entrant/login?award_id=' + parameter_award_id);
                  }
                }
              } else {
                if (surveyId) {
                  history.push('/' + firstPath + '/login?award_id=' + parameter_award_id + '&survey_id=' + surveyId);
                }

                if (module === 'procurement') {
                  history.push('/' + section + '?award_id=' + award_id + '&artwork_id=' + artworkId + '&module=' + module);
                } else {
                  history.push('/' + firstPath + '/login');
                }
              }
            } else {
              window.location.href = 'http://app.businessriver.com/';
            }
          }

          removeCookies();
        }
      }
    }
  }, [awardReady]);

  // useEffect(() => {
  //   // Fetch chat messages of the given meeting from Firestore
  //   if (section === 'entrant') {
  //     const unsubscribe = firestore
  //       .collection("awards")
  //       .doc(award_id)
  //       .collection("entrants")
  //       .doc(currentUser)
  //       .onSnapshot((snapshot) => {
  //         const chatData = snapshot.data();
  //         if (chatData) {
  //           setIsUnreadMessage(chatData.entrant_status === 'You have unread message(s)')
  //         }
  //       });
  //     return () => unsubscribe();
  //   }
  // }, [currentUser]);

  useEffect(() => {
    const fetchUnreadAwards = async () => {
      // VERSION 1 //
      // try {
      //   const awardsSnapshot = await firestore.collection('awards').get();
      //   const unread = [];

      //   for (const awardDoc of awardsSnapshot.docs) {
      //     const awardId = awardDoc.id;
      //     const awardData = awardDoc.data(); // 👈 get the name from here now

      //     const entrantsSnapshot = await firestore
      //       .collection('awards')
      //       .doc(awardId)
      //       .collection('entrants')
      //       .where('admin_status', '==', 'You have unread message(s)')
      //       .get();

      //     if (!entrantsSnapshot.empty) {
      //       unread.push({
      //         awardId,
      //         awardName: awardData.name || 'Untitled Award',
      //         unreadCount: entrantsSnapshot.size,
      //       });
      //     }
      //   }

      //   setUnreadAwards(unread);
      //   setChatsLoading(false);
      // } catch (error) {
      //   console.error('Error fetching unread messages:', error);
      //   setChatsLoading(false);
      // }

      // VERSION 2 //
      getUnreadMessage().then(response => {
        const data = response.data.data;
        if (data) {
          const items = data.map(item => ({
            awardId: item.award_id,
            awardName: item.name || 'Untitled Award',
          }));
          setUnreadAwards(items);
          setChatsLoading(false);
        } else {
          CustomToast.defaultWarning();
        }
      }).catch(() => {
        CustomToast.defaultError();
      });
    };

    fetchUnreadAwards();
  }, [chatsLoading]);

  const logOut = (e) => {
    removeCookies();
    if (action) {
      history.push('/entrant/login?award_id=' + award_id + '&section=' + section + '&action=' + action);
    } else {
      if (section && section != '') {
        if (userRole == 'Admin') {
          history.push('/admin/login');
        } else {
          if (section == 'entrant') {
            // history.push('/entrant/login');
            history.push('/entrant/login?award_id=' + award_id);
          } else if (section == 'judge') {
            // history.push('/judge/login');
            history.push('/judge/login?award_id=' + award_id);
          } else if (section == 'coordinator') {
            // history.push('/coordinator/login');
            history.push('/coordinator/login?award_id=' + award_id);
          } else if (section == 'designer') {
            // history.push('/designer/login');
            history.push('/designer/login?award_id=' + award_id);
          } else if (section == 'printer') {
            // history.push('/printer/login');
            history.push('/printer/login?award_id=' + award_id);
          } else if (section == 'sponsor') {
            // history.push('/sponsor/login');
            history.push('/sponsor/login?award_id=' + award_id);
          } else {
            if (section) {
              history.push('/' + section + '/login?award_id=' + award_id);
            } else {
              history.push('/entrant/login?award_id=' + award_id);
            }

          }
        }
      } else {
        if (userRole == 'Admin') {
          history.push('/admin/login');
        } else {
          history.push('/entrant/login?award_id=' + award_id);
        }
      }
    }
    
  };

  const profile = (e) => {
    if (userRole == 'Admin') {
      history.push('/profile');
    } else {
      history.push('/profile');
    }
  };

  const reloadNotification = (e) => {
    setReloadCount(reloadCount + 1);
  };

  const handleChangePassword = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
      user_id: currentUser,
      token: token,
    });
  };

  const toggleShowPasswordUpdate = () => {
    setShowPasswordUpdate(!showPasswordUpdate);
    if (!showPasswordUpdate) {
      setIsOpenUserCardPopover(false);
      setIsOpenNotificationPopover(false);
      setIsMessageNotificationConfirmed(false);
    }
  };

  //Change Password
  async function changePasswordSubmit() {
    if (passwordData.current_password != '' && passwordData.new_password != '' && passwordData.confirm_password != '') {
      if (passwordData.new_password == passwordData.confirm_password) {
        setFormStatus('loading');
        axios.post(process.env.REACT_APP_API_ENDPOINT + 'password/change?user_id=' + currentUser + '&token=' + token, passwordData).then((response) => {
          const success = response.data.status;
          if (success == 'Success') {
            toast.success('Password updated successfully!', {
              position: 'top-right',
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setReloadCount(reloadCount + 1);
            setFormStatus('standby');
            setShowPasswordUpdate(false);
          } else {
            const errors = response.data.errors;
            for (var i = 0; i < errors.length; i++) {
              toast.error(errors[i], {
                position: 'top-right',
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            setFormStatus('standby');
          }
        }).catch(() => {
          toast.error('An error occured. Please try again or contact the administrator.', {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setFormStatus('standby');
        });
      } else {
        toast.error('New password and Confirm password does not match!', {
          position: 'top-right',
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFormStatus('standby');
      }
    } else {
      toast.error('Please fill up all fiedls!', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setFormStatus('standby');
    }
  };

  useEffect(() => {
    const firstPath = currentPathName.split('/')[1];

    if (awardDomain && awardDomain != "") {
      if (currentHost.includes("bis-administration")) {
        if (firstPath != "admin" && userRole != "Admin") {
          // window.location.replace(
          //   window.location.href.replace("bis-administration.web.app", "businessriver."+awardDomain)
          // );
          const url = new URL(window.location.href);

          // Update domain
          url.hostname = "businessriver." + awardDomain;

          // Update award_id parameter
          if (parameter_award_id && award_id && awardReady) {
            if (parameter_award_id != award_id) {
              url.searchParams.set("award_id", award_id);
            }
          }
          
          // Redirect
          window.location.replace(url.toString());
        }
      } else if (parameter_award_id && award_id && awardReady) {
        if (parameter_award_id != award_id) {
          const url = new URL(window.location.href);

          // Update domain
          url.hostname = "businessriver." + awardDomain;

          // Update award_id parameter
          url.searchParams.set("award_id", award_id);

          // Redirect
          window.location.replace(url.toString());
        }
        
      }
    }
  }, [awardDomain, award_id, awardReady]);

  // ===========================
  // Countdown State Conditions
  // ===========================
  const isEntryNotStarted =
    entryBegin.days > 0 ||
    entryBegin.hours > 0 ||
    entryBegin.minutes > 0;

  const hasJudgingBegins = !Number.isNaN(judgingBegins.days);
  const hasJudgingDeadline = !Number.isNaN(judgingTimeLeft.days);

  const isJudgingNotStarted =
    judgingBegins.days > 0 ||
    judgingBegins.hours > 0 ||
    judgingBegins.minutes > 0;

  const hasShortlistingBegins = !Number.isNaN(shortlistingBegins.days);
  const hasShortlistingDeadline = !Number.isNaN(shortlistingTimeLeft.days);

  const isShortlistingNotStarted =
    shortlistingBegins.days > 0 ||
    shortlistingBegins.hours > 0 ||
    shortlistingBegins.minutes > 0;

  const isDeadlinePassed =
    entryDeadline.days < 0 &&
    entryDeadline.hours < 0 &&
    entryDeadline.minutes < 0;

  const hasExtension = !Number.isNaN(entryDeadlineExtension.days);

  const isExtensionActive =
    hasExtension &&
    (
      entryDeadlineExtension.days > 0 ||
      entryDeadlineExtension.hours > 0 ||
      entryDeadlineExtension.minutes > 0
    );

  const isExtensionPassed =
    hasExtension &&
    entryDeadlineExtension.days < 0 &&
    entryDeadlineExtension.hours < 0 &&
    entryDeadlineExtension.minutes < 0;

  const isGalaPassed =
    galaDate.days < 0 &&
    galaDate.hours < 0 &&
    galaDate.minutes < 0;

  const isJudgingBegins =
    judgingBegins.days < 0 &&
    judgingBegins.hours < 0 &&
    judgingBegins.minutes < 0;

  const isSubmissionsOpen =
    entryDeadline.days > 0 || entryDeadline.hours > 0 || entryDeadline.minutes > 0 

  return (
    <>
      <ToastContainer style={{ width: '370px' }} />
      <Navbar light expand className={bem.b('bg-white')}>
        <Container>
          <Nav navbar className='mr-2'>
            {/* {userRole == "Admin" ?
              <a href="/admin" className="navbar-brand d-block mr-auto ml-auto text-black">
                <img
                  src={Logo}
                  width="150"
                  className=""
                  alt="BIS"
                />
              </a>
              :
              <>
              <img
                src={Logo}
                width="150"
                className=""
                alt="BIS"
              />
              </>
              // <SourceLink className="navbar-brand d-block mr-auto ml-auto text-black">
              //   <img
              //     src={Logo}
              //     width="150"
              //     className=""
              //     alt="BIS"
              //   />
              // </SourceLink>
            } */}
          </Nav>
          {userRole != 'Admin' ?
            <Nav navbar className='timer-container big'>
              {/*<SearchInput />*/}
              {section === 'sponsor' ?
                <>
                  {/* {eventLogo && eventLogo !== '' ?
                    <img src={eventLogo}
                      height='75'
                      className='mr-3'
                    />
                    :
                    null
                  } */}
                </>
                :
                null
              }
              <>
                {entryDeadline.days || entryDeadline.hours || entryDeadline.minutes || judgingTimeLeft.days || judgingTimeLeft.hours || judgingTimeLeft.minutes ?
                  (
                    <>
                      {/* <p className="mb-0"><strong className='entrant-award-subheader'>SUBMISSION OF ENTRIES ENDS IN</strong></p> */}
                      {section == 'judge' && !isGalaPassed ?
                        <>
                          {!hasJudgingBegins ?
                            <p className='mb-0'>
                              <strong className='entrant-award-subheader'>
                                JUDGING START DATE HAS NOT YET BEEN ANNOUNCED
                              </strong>
                            </p>
                          :
                            isJudgingNotStarted
                              ?
                                <>
                                  <p className='mb-0'>
                                    <strong className='entrant-award-subheader'>
                                      JUDGING PERIOD STARTS IN
                                    </strong>
                                  </p>
                                  <ul className='list-inline text-center'>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='days-timer'>{judgingBegins.days}</span><br />
                                        <span className='timer-text'>DAYS</span>
                                      </div>
                                    </li>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='hours-timer'>{judgingBegins.hours}</span><br />
                                        <span className='timer-text'>HOURS</span>
                                      </div>
                                    </li>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='mins-timer'>{judgingBegins.minutes}</span><br />
                                        <span className='timer-text'>MINUTES</span>
                                      </div>
                                    </li>
                                  </ul>
                                </>
                            : !hasJudgingDeadline ?
                                <p className='mb-0'>
                                  <strong className='entrant-award-subheader'>
                                    JUDGING END DATE HAS NOT YET BEEN ANNOUNCED
                                  </strong>
                                </p>
                            : judgingTimeLeft.days > 0 || judgingTimeLeft.hours > 0 || judgingTimeLeft.minutes > 0 ?
                                <>
                                  <p className='mb-0'>
                                    <strong className='entrant-award-subheader'>
                                      JUDGING PERIOD ENDS IN
                                    </strong>
                                  </p>
                                  <ul className='list-inline text-center'>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='days-timer'>{judgingTimeLeft.days}</span><br />
                                        <span className='timer-text'>DAYS</span>
                                      </div>
                                    </li>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='hours-timer'>{judgingTimeLeft.hours}</span><br />
                                        <span className='timer-text'>HOURS</span>
                                      </div>
                                    </li>
                                    <li className='list-inline-item justify-content-center'>
                                      <div className='timer-info'>
                                        <span className='mins-timer'>{judgingTimeLeft.minutes}</span><br />
                                        <span className='timer-text'>MINUTES</span>
                                      </div>
                                    </li>
                                  </ul>
                                </>
                            :
                                <p className='mb-0'>
                                  <strong className='entrant-award-subheader'>
                                    JUDGING PERIOD HAS ENDED
                                  </strong>
                                </p>
                          }
                        </>
                      : section == 'entrant' ?
                          <>
                            {isEntryNotStarted 
                                ?
                                  <>
                                    <p className='mb-0'>
                                      <strong className='entrant-award-subheader'>
                                        SUBMISSION OF ENTRIES OPENS IN
                                      </strong>
                                    </p>
                                    <ul className='list-inline text-center'>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='days-timer'>{entryBegin.days}</span><br />
                                          <span className='timer-text'>DAYS</span>
                                        </div>
                                      </li>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='hours-timer'>{entryBegin.hours}</span><br />
                                          <span className='timer-text'>HOURS</span>
                                        </div>
                                      </li>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='mins-timer'>{entryBegin.minutes}</span><br />
                                          <span className='timer-text'>MINUTES</span>
                                        </div>
                                      </li>
                                    </ul>
                                  </>
                              :isDeadlinePassed && isExtensionActive
                                ?  
                                  <>
                                    <p className='mb-0'>
                                      <strong className='entrant-award-subheader'>
                                        SUBMISSION OF ENTRIES IS EXTENDED
                                      </strong>
                                    </p>
                                    <ul className='list-inline text-center'>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='days-timer'>{entryDeadlineExtension.days}</span><br />
                                          <span className='timer-text'>DAYS</span>
                                        </div>
                                      </li>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='hours-timer'>{entryDeadlineExtension.hours}</span><br />
                                          <span className='timer-text'>HOURS</span>
                                        </div>
                                      </li>
                                      <li className='list-inline-item justify-content-center'>
                                        <div className='timer-info'>
                                          <span className='mins-timer'>{entryDeadlineExtension.minutes}</span><br />
                                          <span className='timer-text'>MINUTES</span>
                                        </div>
                                      </li>
                                    </ul>
                                  </>
                                : isSubmissionsOpen
                                  ? 
                                    <>
                                      <p className='mb-0'>
                                        <strong className='entrant-award-subheader'>
                                          SUBMISSION OF ENTRIES ENDS IN
                                        </strong>
                                      </p>
                                      <ul className='list-inline text-center'>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='days-timer'>{entryDeadline.days}</span><br />
                                            <span className='timer-text'>DAYS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='hours-timer'>{entryDeadline.hours}</span><br />
                                            <span className='timer-text'>HOURS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='mins-timer'>{entryDeadline.minutes}</span><br />
                                            <span className='timer-text'>MINUTES</span>
                                          </div>
                                        </li>
                                      </ul>
                                    </>
                                  : isGalaPassed && awardStatus == 'Closed' ?

                                    null
                                    
                                  :
                                    <p className='mb-0'>
                                      <strong className='entrant-award-subheader'>
                                        SUBMISSION OF ENTRIES HAS ENDED
                                      </strong>
                                    </p>
                                
                            }
                          </>
                          : section == 'coordinator' && !isGalaPassed && !isJudgingBegins ?
                            <>
                              {!hasShortlistingBegins ?
                                <p className='mb-0'>
                                  <strong className='entrant-award-subheader'>
                                    SHORTLISTING START DATE HAS NOT YET BEEN ANNOUNCED
                                  </strong>
                                </p>
                              :
                                isShortlistingNotStarted
                                  ?
                                    <>
                                      <p className='mb-0'>
                                        <strong className='entrant-award-subheader'>
                                          SHORTLISTING PERIOD STARTS IN
                                        </strong>
                                      </p>
                                      <ul className='list-inline text-center'>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='days-timer'>{shortlistingBegins.days}</span><br />
                                            <span className='timer-text'>DAYS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='hours-timer'>{shortlistingBegins.hours}</span><br />
                                            <span className='timer-text'>HOURS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='mins-timer'>{shortlistingBegins.minutes}</span><br />
                                            <span className='timer-text'>MINUTES</span>
                                          </div>
                                        </li>
                                      </ul>
                                    </>
                                : !hasShortlistingDeadline ?
                                    <p className='mb-0'>
                                      <strong className='entrant-award-subheader'>
                                        SHORTLISTING END DATE HAS NOT YET BEEN ANNOUNCED
                                      </strong>
                                    </p>
                                : shortlistingTimeLeft.days > 0 || shortlistingTimeLeft.hours > 0 || shortlistingTimeLeft.minutes > 0 ?
                                    <>
                                      <p className='mb-0'>
                                        <strong className='entrant-award-subheader'>
                                          SHORTLISTING PERIOD ENDS IN
                                        </strong>
                                      </p>
                                      <ul className='list-inline text-center'>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='days-timer'>{shortlistingTimeLeft.days}</span><br />
                                            <span className='timer-text'>DAYS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='hours-timer'>{shortlistingTimeLeft.hours}</span><br />
                                            <span className='timer-text'>HOURS</span>
                                          </div>
                                        </li>
                                        <li className='list-inline-item justify-content-center'>
                                          <div className='timer-info'>
                                            <span className='mins-timer'>{shortlistingTimeLeft.minutes}</span><br />
                                            <span className='timer-text'>MINUTES</span>
                                          </div>
                                        </li>
                                      </ul>
                                    </>
                                :
                                    <p className='mb-0'>
                                      <strong className='entrant-award-subheader'>
                                        SHORTLISTING PERIOD HAS ENDED
                                      </strong>
                                    </p>
                              }
                            </>
                            :
                            null
                      }

                    </>
                  ) : (
                    <>
                      {section == 'judge' && !isGalaPassed?
                        <>
                          {/* <p className="mb-0"><strong className='entrant-award-subheader'>SUBMISSION OF ENTRIES ENDS IN</strong></p> */}
                          <p className='mb-0'>
                            {judge == '1' ?
                              <strong className='entrant-award-subheader'>
                                JUDGING PERIOD ENDS IN
                              </strong>
                              :
                              <strong className='entrant-award-subheader'>
                                SUBMISSION OF ENTRIES ENDS IN
                              </strong>
                            }
                          </p>
                          <ul className='list-inline text-center'>
                            <li className='list-inline-item justify-content-center'>
                              <div className='timer-info'>
                                <span className='days-timer'>--</span><br />
                                <span className='timer-text'>DAYS</span>
                              </div>
                            </li>
                            <li className='list-inline-item justify-content-center'>
                              <div className='timer-info'>
                                <span className='hours-timer'>--</span><br />
                                <span className='timer-text'>HOURS</span>
                              </div>
                            </li>
                            <li className='list-inline-item justify-content-center'>
                              <div className='timer-info'>
                                <span className='mins-timer'>--</span><br />
                                <span className='timer-text'>MINUTES</span>
                              </div>
                            </li>
                          </ul>
                        </>
                        : section == 'entrant' && !isGalaPassed ?
                          <>
                            {/* <p className="mb-0"><strong className='entrant-award-subheader'>SUBMISSION OF ENTRIES ENDS IN</strong></p> */}
                            <p className='mb-0'>
                              <strong className='entrant-award-subheader'>
                                SUBMISSION OF ENTRIES ENDS IN
                              </strong>
                            </p>
                            <ul className='list-inline text-center'>
                              <li className='list-inline-item justify-content-center'>
                                <div className='timer-info'>
                                  <span className='days-timer'>--</span><br />
                                  <span className='timer-text'>DAYS</span>
                                </div>
                              </li>
                              <li className='list-inline-item justify-content-center'>
                                <div className='timer-info'>
                                  <span className='hours-timer'>--</span><br />
                                  <span className='timer-text'>HOURS</span>
                                </div>
                              </li>
                              <li className='list-inline-item justify-content-center'>
                                <div className='timer-info'>
                                  <span className='mins-timer'>--</span><br />
                                  <span className='timer-text'>MINUTES</span>
                                </div>
                              </li>
                            </ul>
                          </>
                          : section == 'coordinator' && !isGalaPassed && !isJudgingBegins ?
                            <>
                              {/* <p className="mb-0"><strong className='entrant-award-subheader'>SUBMISSION OF ENTRIES ENDS IN</strong></p> */}
                              <p className='mb-0'>
                                <strong className='entrant-award-subheader'>
                                  SHORTLISTING PERIOD ENDS IN
                                </strong>
                              </p>
                              <ul className='list-inline text-center'>
                                <li className='list-inline-item justify-content-center'>
                                  <div className='timer-info'>
                                    <span className='days-timer'>--</span><br />
                                    <span className='timer-text'>DAYS</span>
                                  </div>
                                </li>
                                <li className='list-inline-item justify-content-center'>
                                  <div className='timer-info'>
                                    <span className='hours-timer'>--</span><br />
                                    <span className='timer-text'>HOURS</span>
                                  </div>
                                </li>
                                <li className='list-inline-item justify-content-center'>
                                  <div className='timer-info'>
                                    <span className='mins-timer'>--</span><br />
                                    <span className='timer-text'>MINUTES</span>
                                  </div>
                                </li>
                              </ul>
                            </>
                            :
                            null
                      }
                    </>
                  )
                }
              </>
            </Nav>
            :
            null
          }

          <Nav navbar className={bem.e('nav-right')}>
            {!currentUser ?
              <NavItem className='d-inline-flex'>
                <NavLink className='position-relative mr-2 text-dark'
                  href={`/entrant/login?award_id=${award_id}`}>
                  Login
                </NavLink>
                <NavLink className='position-relative mr-2 text-dark'
                  href={`/entrant/register?award_id=${award_id}`}>
                  Register
                </NavLink>
              </NavItem>
              :
              <NavItem className='d-inline-flex'>
                {userRole == 'Admin' ?
                  <>
                    <NavLink className='position-relative mr-2 text-dark' href='/admin'>
                      Home
                    </NavLink>
                    {user ?
                      <>
                        {user.venues_view == 1 ?
                          <NavLink className='position-relative mr-2 text-dark' href='/admin/venues'>
                            Venues
                          </NavLink>
                          :
                          null
                        }
                      </>
                      :
                      null
                    }

                    {user ?
                      <>
                        {user.invoices_view == 1 ?

                          <div className='position-relative mr-2 text-dark dropdown-menu-nav' href='#'>
                            <NavLink className='position-relative p-0 text-dark' href='#'>
                              Finance
                            </NavLink>
                            <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                              <NavLink className='position-relative text-dark' href='/admin/invoices'>
                                Invoices
                              </NavLink>
                              <NavLink className='position-relative text-dark' href='/admin/price-quote'>
                                Price Quotes
                              </NavLink>
                              <NavLink className='position-relative text-dark' href='/admin/bank/transfers'>
                                Bank Transfers
                              </NavLink>
                              <NavLink className='position-relative text-dark' href='/admin/booking/forms'>
                                Award Booking Forms
                              </NavLink>
                              {/* <NavLink className='position-relative text-dark' href='/admin/conference/booking/forms'>
                                Conference Booking Forms
                              </NavLink> */}
                            </div>
                          </div>
                          :
                          null
                        }
                      </>
                      :
                      null
                    }
                    {/* <NavLink className="position-relative mr-2 text-dark" href="/admin/artworktype">
                      Artwork
                    </NavLink> */}
                    {user ?
                      <>
                        {user.users_view == 1 ?
                          <>
                            <NavLink className='position-relative mr-2 text-dark' href='/admin/users'>
                              Users
                            </NavLink>
                            <NavLink className='position-relative mr-2 text-dark' href='/admin/contacts'>
                              Contacts
                            </NavLink>
                          </>
                          :
                          null
                        }
                      </>
                      :
                      null
                    }
                    {user ?
                      <>
                        {user.judging_settings == 1 ?
                          <>
                            <div className='position-relative mr-2 text-dark dropdown-menu-nav' href='#'>
                              <NavLink className='position-relative p-0 text-dark' href='#'>
                                Roles
                              </NavLink>
                              <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                                <NavLink className='position-relative text-dark' href='/admin/judges'>
                                  Judges
                                </NavLink>
                                <NavLink className='position-relative text-dark' href='/admin/coordinators'>
                                  Coordinators
                                </NavLink>
                                <NavLink className='position-relative text-dark' href='/admin/panellists'>
                                  Panellists
                                </NavLink>
                                <NavLink className='position-relative text-dark' href='/admin/speakers'>
                                  Speakers
                                </NavLink>
                                <NavLink className='position-relative text-dark' href='/admin/steering-committee'>
                                  Steering Committee
                                </NavLink>
                                <NavLink className='position-relative text-dark' href='/admin/keynote-speakers'>
                                  Keynote Speakers
                                </NavLink>
                              </div>
                            </div>
                          </>
                          :
                          null
                        }
                      </>
                      :
                      null
                    }
                  </>
                  :
                  <>
                    <NavLink className='position-relative mr-2 text-dark' href={`/${section ? section : 'entrant'}/home`}>
                      Home
                    </NavLink>
                  </>
                }
                {userDetails && userDetails.user && userDetails.user.admin_privileges ?
                  <>
                    {userDetails.user.admin_privileges === 'Script' && (
                      <NavLink className='position-relative mr-2 text-dark dropdown-menu-nav' href='/admin/users'>
                        <NavLink className='position-relative p-0 text-dark' href='#'>
                          Settings
                        </NavLink>
                        <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                          <NavLink className='position-relative text-dark' href='/admin/scripts'>
                            Script
                          </NavLink>
                        </div>
                      </NavLink>
                    )}
                  </>
                  :
                  <>
                    {userRole == 'Admin' ?
                      <>
                        <NavLink className='position-relative mr-2 text-dark' href='/admin/tickets'>
                          Tickets
                        </NavLink>
                        <NavLink className='position-relative mr-2 text-dark' href='/admin/report/survey'>
                          Reports
                        </NavLink>
                      </>
                      :
                      null
                    }
                    {userRole == 'Admin' ?
                      <>
                        <NavLink className='position-relative mr-2 text-dark dropdown-menu-nav' href='/admin/users'>
                          <NavLink className='position-relative p-0 text-dark' href='#'>
                            Settings
                          </NavLink>
                          <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                            <NavLink className='position-relative text-dark' href='/admin/project-types'>
                              Supplier Types
                            </NavLink>
                            <NavLink className='position-relative text-dark' href='/admin/scripts'>
                              Script
                            </NavLink>
                            <NavLink className='position-relative text-dark' href='/admin/sponsorship/types'>
                              Sponsorship Types
                            </NavLink>
                            <NavLink className='position-relative text-dark' href='/admin/sponsorship/features'>
                              Sponsorship Features
                            </NavLink>
                            <NavLink className='position-relative text-dark' href='/admin/blacklist'>
                              Blacklists
                            </NavLink>
                            <NavLink className='position-relative mr-2 text-dark' href='/admin/blocked-mails'>
                              Blocked Mails
                            </NavLink>
                            <NavLink className='position-relative mr-2 text-dark' href='/admin/requisitions'>
                              Requisition Forms
                            </NavLink>
                          </div>
                        </NavLink>
                      </>
                      :
                      null
                    }
                  </>
                }
                {userRole == 'Admin' ?
                  <>
                    <NavLink className='position-relative mr-2 text-dark' href='/admin/chats'>
                      Chats
                    </NavLink>
                  </>
                  :
                  null
                }
                {/* {userRole != "Admin" ?
                  <>
                    <NavLink className="position-relative mr-2 text-dark" href="#" onClick={handleShowContact}>
                      <img src={CostumerServiceIcon} className="mr-2" />
                      Contact Us
                    </NavLink>
                  </>
                  :
                  null
                } */}
                <Modal
                  isOpen={showContact}
                  className='modal-preview'
                  fade={false}
                  centered
                  id='edit-judge-modal'
                >
                  <ModalHeader className='text-left'>
                    CONTACT US
                    <button type='button' className='close react-modal-close' data-dismiss='modal' aria-label='Close'
                      onClick={handleClose}>
                      <span aria-hidden='true'>&times;</span>
                    </button>
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col lg='12'>
                        <Card>
                          <CardBody className='card_container'>
                            {/* <FormGroup>
                              <Input type="hidden" name="name" onChange={handleChange} value={user.first_name + " " + user.last_name} />
                            </FormGroup>
                            <FormGroup>
                              <Input type="hidden" name="email"  onChange={handleChange} value={user.email} />
                            </FormGroup> */}
                            <FormGroup>
                              <Input type='text' name='subject' maxLength={255} onChange={handleChange}
                                placeholder='Subject' />
                            </FormGroup>
                            <FormGroup>
                              <Input type='textarea' rows='5' name='message' onChange={handleChange}
                                placeholder='Message' />
                            </FormGroup>
                          </CardBody>
                          <CardFooter className='text-right'>
                            <button type='button' className='btn btn-main btn-main-alt mr-3' data-dismiss='modal'
                              onClick={handleClose}>Close
                            </button>
                            {formStatus == 'standby' ?
                              <button type='button' className='btn newbtntheme primary-btn'
                                onClick={submitContact}>Send</button>
                              :
                              <button type='button' className='btn newbtntheme primary-btn'
                                onClick={preventDefault}>Sending...</button>
                            }
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>

                <Modal
                  isOpen={showPasswordUpdate}
                  className='modal-preview'
                  fade={false}
                  centered
                // id="edit-judge-modal"
                >
                  <ModalHeader className='text-left'>
                    CHANGE PASSWORD
                    <button type='button' className='close react-modal-close' data-dismiss='modal' aria-label='Close'
                      onClick={toggleShowPasswordUpdate}>
                      <span aria-hidden='true'>&times;</span>
                    </button>
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col lg='12'>
                        <Card>
                          <CardBody className='card_container'>
                            <FormGroup>
                              <label htmlFor='password'>Password</label>
                              <Input type='password' name='current_password' onChange={handleChangePassword}
                                placeholder='Password' />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor='password'>New Password</label>
                              <Input type='password' name='new_password' onChange={handleChangePassword}
                                placeholder='New Password' />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor='password'>Confirm Password</label>
                              <Input type='password' name='confirm_password' onChange={handleChangePassword}
                                placeholder='Confirm Password' />
                            </FormGroup>
                          </CardBody>
                          <CardFooter className='text-right'>
                            <button type='button' className='btn btn-main btn-main-alt mr-3' data-dismiss='modal'
                              onClick={toggleShowPasswordUpdate}>Close
                            </button>
                            {formStatus == 'standby' ?
                              <button type='button' className='btn newbtntheme primary-btn'
                                onClick={changePasswordSubmit}>Save</button>
                              :
                              <button type='button' className='btn newbtntheme primary-btn'
                                onClick={preventDefault}>Saving...</button>
                            }
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
                {/* <NavLink type="button" className="position-relative mr-3 text-dark" data-toggle="modal" data-target="#exampleModalLong">
                Contact Us
              </NavLink>
              <div className="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLongTitle">Modal title</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      ...
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                      <button type="button" className="btn btn-primary">Save changes</button>
                    </div>
                  </div>
                </div>
              </div> */}
              </NavItem>
            }
            {!(userRole != 'Admin' || (userRole == 'Admin' && userDetails && userDetails.user && userDetails.user.admin_privileges)) && (
              <>
                <NavItem className='d-inline-flex'>
                  <NavLink id='Popover1' className='position-relative mr-2'>
                    {isNotificationConfirmed || notificationsCount < 1 ? (
                      <MdNotificationsNone
                        size={25}
                        className='text-secondary can-click'
                        onClick={toggleNotificationPopover}
                      />
                    ) : (
                      <MdNotificationsActiveWithBadge
                        size={25}
                        className='text-secondary can-click swing infinite'
                        onClick={toggleNotificationPopover}
                      />
                    )}
                  </NavLink>
                  <Popover
                    placement='bottom-end'
                    isOpen={isOpenNotificationPopover}
                    toggle={toggleNotificationPopover}
                    target='Popover1'
                    className='notifications-popup'
                  >
                    <PopoverBody>
                      <Notifications notificationsData={notifications} userRole={userRole} currentUser={currentUser}
                        reloadHeader={reloadNotification} />
                    </PopoverBody>
                    {/* <a href="/notifications">
                  <div className='btn newbtntheme border-left-0 border-bottom-0 border-right-0 w-100 text-center'>
                    VIEW ALL
                  </div>
                </a> */}
                  </Popover>
                </NavItem>
                <NavItem className='d-inline-flex'>
                  <NavLink id='ChatPopover' className='position-relative mr-2'>
                    {isChatNotificationConfirmed || unreadAwards.length < 1 ? (
                      <TbMessageDots
                        size={25}
                        className='text-secondary can-click'
                        onClick={toggleChatPopover}
                      />
                    ) : (
                      <TbMessageReportFilledBadge
                        size={25}
                        className='text-secondary can-click swing infinite'
                        onClick={toggleChatPopover}
                      />
                    )}
                  </NavLink>
                  <Popover
                    placement='bottom-end'
                    isOpen={isOpenChatPopover}
                    toggle={toggleChatPopover}
                    target='ChatPopover'
                    className='chat-notifications-popup'
                  >
                    <PopoverBody>
                      <ChatNotifications
                        userRole={userRole}
                        currentUser={currentUser}
                        loading={chatsLoading}
                        unreadAwards={unreadAwards}
                      />
                    </PopoverBody>
                  </Popover>
                </NavItem>
              </>

            )}
            {/* <NavItem className="d-inline-flex">
              <NavLink id="Popover2" className="position-relative">
                {isMessageNotificationConfirmed ? (
                  <MdMessage
                    size={25}
                    className="text-secondary can-click"
                    onClick={toggleMessageNotificationPopover}
                  />
                ) : (
                  <MdMessagesActiveWithBadge
                    size={25}
                    className="text-secondary can-click animated swing infinite"
                    onClick={toggleMessageNotificationPopover}
                  />
                )}
              </NavLink>
              <Popover
                placement="bottom"
                isOpen={isOpenMessageNotificationPopover}
                toggle={toggleMessageNotificationPopover}
                target="Popover2"
              >
                <PopoverBody>
                  <Notifications notificationsData={notificationsData} />
                </PopoverBody>
                </Popover>
            </NavItem> */}
            {currentUser ?
              <NavItem>
                <NavLink id='Popover3'>
                  {/* <Avatar
                    onClick={toggleUserCardPopover}
                    className="can-click"
                    src={imgFile ? imgFile : null}
                  //src={user.avatar}
                  /> */}
                  {imgFile ?
                    <div onClick={toggleUserCardPopover} className='profile-picture-container cursor-pointer' style={{
                      backgroundImage: 'url(' + process.env.REACT_APP_URL + 'storage/user/' + imgFile + ')',
                      width: '50px',
                      height: '50px',
                    }}></div>
                    :
                    <div onClick={toggleUserCardPopover} className='profile-picture-container cursor-pointer'
                      style={{ backgroundImage: 'url(' + ProfileImage + ')', width: '50px', height: '50px' }}></div>
                  }
                </NavLink>
                <Popover
                  placement='bottom-end'
                  isOpen={isOpenUserCardPopover}
                  toggle={toggleUserCardPopover}
                  target='Popover3'
                  className='p-0 border-0'
                  style={{ minWidth: 250 }}
                >
                  <PopoverBody className='p-0'>
                    <UserCard
                      //title={user.first_name +" "+ user.last_name}
                      title={user.first_name}
                      //title="Administrator"
                      //subtitle="customercare@businessriver.com"
                      //subtitle={currentUser.user.email}
                      //text="Last updated 3 mins ago"
                      className='border-light'
                      avatar={imgFile ? imgFile : null}
                    //avatar={user.avatar}
                    >
                      <ListGroup flush>
                        {/* {userRole != 'Admin' ?
                          <ListGroupItem tag='button' onClick={profile} action className=''>
                            <MdPersonPin style={{ fontSize: '20px' }} /> Profile
                          </ListGroupItem>
                          :
                          null
                        } */}
                        {/*<ListGroupItem tag="button" action className="border-light">
                        <MdInsertChart /> Stats
                      </ListGroupItem>
                      <ListGroupItem tag="button" action className="border-light">
                        <MdMessage /> Messages
                      </ListGroupItem>
                      */}
                        <ListGroupItem tag='button' onClick={toggleShowPasswordUpdate} action className='border-light'>
                          <MdSettingsApplications style={{ fontSize: '20px' }} /> Change Password
                        </ListGroupItem>
                        {/*<ListGroupItem tag="button" action className="border-light">
                        <MdHelp /> Help
                      </ListGroupItem>*/}
                        <ListGroupItem tag='button' onClick={logOut} action className=''>
                          <MdExitToApp style={{ fontSize: '20px' }} /> Logout
                        </ListGroupItem>
                      </ListGroup>
                    </UserCard>
                  </PopoverBody>
                </Popover>
              </NavItem>
              :
              null
            }
          </Nav>
        </Container>
        {/* {currentPathName == "/register" || currentPathName == "/bank/transfer" || currentPathName == "/bank/transfer/terms" || currentPathName == "/report" || currentPathName == "/award/book" || currentPathName == "/award/book/seats" || currentPathName == "/award/event" || currentPathName == "/booking/summary" || currentPathName == "/booking/summary/unlisted" || currentPathName == "/booking/details" || currentPathName == "/booking/payment/success" || currentPathName == "/booking/attendees" || currentPathName == "/booking/attendees/setup" || currentPathName == "/category/winner" || currentPathName == "/award/winner" || currentPathName == "/award/nomination" || currentPathName == "/winner/summary" || currentPathName == "/winner/payment/success" || currentPathName == "/bank/transfer" || currentPathName == "/bank/transfer/terms" || currentPathName == "/tickets" ?
            null
            :
            <LiveChatWidget
              license="15095595"
              visibility="maximized"
              onNewEvent={handleNewEvent}
            />
        } */}

        {/*{currentPathName == "/entrant/gallery" || currentPathName == "/entrant/gallery/selections" || currentPathName == "/entrant/gallery/timeline" ?*/}

        {/*  <LiveChatWidget*/}
        {/*    license="15095595"*/}
        {/*    visibility="maximized"*/}
        {/*    onNewEvent={handleNewEvent}*/}
        {/*  />*/}
        {/*  :*/}
        {/*  null*/}
        {/*}*/}
        {/*{awardStatus != "" ?*/}
        {/*  <>*/}
        {/*    {currentPathName == "/entrant/home" && awardStatus == "Closed" ?*/}
        {/*      <LiveChatWidget*/}
        {/*        license="15095595"*/}
        {/*        visibility="maximized"*/}
        {/*        onNewEvent={handleNewEvent}*/}
        {/*      />*/}
        {/*      :*/}
        {/*      null*/}
        {/*    }*/}
        {/*  </>*/}
        {/*  :*/}
        {/*  null*/}
        {/*}*/}

      </Navbar>
    </>
  );
}

export default Header;
